import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'addressFormat'
})
export class AddressFormatPipe implements PipeTransform {
  transform(address: any, placeholderAddress?: any): string {

    if (address?.City?.length || address?.State?.length || address?.PostalCode?.length || placeholderAddress?.City?.length || placeholderAddress?.State?.length || placeholderAddress?.PostalCode?.length)
      return `${address?.Street1 || placeholderAddress?.Street1 || ''} ${((address?.Street1 || placeholderAddress?.Street1 || '').length ? '<br />' : '')}  ${(address?.City || placeholderAddress?.City || '')}${((address?.City || placeholderAddress?.City || '').length ? ((address?.State || placeholderAddress?.State || '').length > 0? ',' : '') : '')} ${address?.State || placeholderAddress?.State || ''} ${address?.PostalCode || placeholderAddress?.PostalCode || ''}`;

    if ((address?.Street1 || placeholderAddress?.Street1 || '').length)
      return `${(address?.Street1 || placeholderAddress?.Street1 || '')}`;

    const lat = address?.Latitude ?? placeholderAddress?.Latitude;
    const lng = address?.Longitude ?? placeholderAddress?.Longitude;
    if (lat != null && lng != null) {
      return `(${lat}, ${lng})`;
    }
    return '';
  }

}
